import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchCategories,
  createCategory,
  updateCategory,
  deleteCategory
} from "../redux/slices/blogCategorySlice";

const BlogCategoryManager = () => {
  const dispatch = useDispatch();

  const { categories, loading } = useSelector(
    (state) => state.blogCategory
  );

  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ categoryName: "" });
  const [editingId, setEditingId] = useState(null);

  // ✅ Fetch
  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  // ✅ Input
  const handleChange = (e) => {
    setForm({ categoryName: e.target.value });
  };

  // ✅ Open Create
  const handleCreate = () => {
    setForm({ categoryName: "" });
    setEditingId(null);
    setShowModal(true);
  };

  // ✅ Open Edit
  const handleEdit = (cat) => {
    setForm({ categoryName: cat.categoryName });
    setEditingId(cat.categoryId);
    setShowModal(true);
  };

  // ✅ Submit
  const handleSubmit = async () => {
    if (!form.categoryName) {
      alert("Enter category name");
      return;
    }

    if (editingId) {
      await dispatch(updateCategory({ id: editingId, data: form }));
    } else {
      await dispatch(createCategory(form));
    }

    setShowModal(false);
  };

  // ✅ Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    await dispatch(deleteCategory(id));
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between mb-3">
        <h4>Blog Categories</h4>
        <button className="btn btn-primary" onClick={handleCreate}>
          + Create Category
        </button>
      </div>

      {loading && <p>Loading...</p>}

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {categories.map((cat) => (
            <tr key={cat._id}>
              <td>{cat.categoryId}</td>
              <td>{cat.categoryName}</td>
              <td>
                <button
                  className="btn btn-warning btn-sm me-2"
                  onClick={() => handleEdit(cat)}
                >
                  Edit
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(cat.categoryId)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ✅ Modal */}
      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5>
                  {editingId ? "Update Category" : "Create Category"}
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                />
              </div>

              <div className="modal-body">
                <input
                  type="text"
                  value={form.categoryName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Category name"
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  {editingId ? "Update" : "Create"}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogCategoryManager;